import { Injectable, inject } from '@angular/core';
import { ConfigService } from '@cue-admin/config';
import { HttpClient } from '@angular/common/http';
import { TreeListDataResult } from '@progress/kendo-angular-treelist';
import { toDataSourceRequestString } from '@progress/kendo-data-query';
import { Observable } from 'rxjs';
import { CONSTANTS } from '@cue-admin/constants';
import { TreelistErrors } from '../models/treelist-errors.model';
import { TreelistPayload } from '../models/treelistPayload';

export interface TreelistDataResponse extends TreeListDataResult {
  errors: TreelistErrors;
}

@Injectable({
  providedIn: 'root',
})
export class TreelistDataService {
  private configService = inject(ConfigService);
  private http = inject(HttpClient);

  fetchData(
    urlPostfix: string,
    event: Parameters<typeof toDataSourceRequestString>[0],
    addition: unknown,
    payload?: TreelistPayload
  ): Observable<TreelistDataResponse> {
    const config = this.configService.value;
    if (!config) {
      throw new Error('Application config is not loaded.');
    }

    const url = `${config.apiURL}`;
    /*if (urlPostfix == "/file/treelist") {
      url = "https://private-7f9a1-touchoneadminapi.apiary-mock.com";
    }*/
    const queryString = toDataSourceRequestString(event);
    let requestUrl = url + CONSTANTS.api.prefix + urlPostfix + '?' + queryString;
    if (addition) {
      requestUrl += '&addition=' + encodeURIComponent(JSON.stringify(addition));
    }
    return this.http.post<TreelistDataResponse>(requestUrl, { data: payload });
  }
}
